import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';
import { S as StringService } from './index2.js';
import { T as TrackingService, D as DomService } from './index3.js';
import { T as TranslationService } from './index6.js';

const rochePopularSearchCss = ":host{display:block;margin-top:3rem;margin-top:0}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}@media (min-width: 64rem){:host{margin-top:0}}:host .popular-search{font-family:\"roche-sans\";font-style:normal;font-weight:200;font-size:var(--body-small--font-size--small-up);line-height:1.625rem;margin-top:1.5rem;color:#706b69;cursor:pointer}@media (min-width: 48rem){:host .popular-search{font-size:var(--body-small--font-size--medium-up);line-height:1.8125rem}}";
const RochePopularSearchStyle0 = rochePopularSearchCss;

const RochePopularSearch$1 = /*@__PURE__*/ proxyCustomElement(class RochePopularSearch extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.searchTermClickEvent = createEvent(this, "rochePopularSearchTermClick", 7);
        this.triggerSearch = (event) => {
            this.searchTermClickEvent.emit(event);
            TrackingService.push(this.defaultTracking);
        };
        this.label = undefined;
        this.value = undefined;
        this.translations = undefined;
    }
    async componentWillLoad() {
        this.translations = {
            label: await TranslationService.translate(this.label, DomService.getGlobalConfig().locale, DomService.getGlobalConfig().popularSearchesTranslationUrl),
        };
    }
    render() {
        return (h("div", { key: '6004a70d1f7c2a3520f736c5c423c0208d67a228', class: "popular-search" }, h("span", { key: '1cd298a291156e09b154d7dd16fb5c12eec63226', onClick: this.triggerSearch }, StringService.capitalize(this.translations.label))));
    }
    // eslint-disable-next-line class-methods-use-this
    get defaultTracking() {
        return {
            event: 'popular_search_click',
            component_name: 'roche-popular-search',
            value: this.label,
        };
    }
    static get style() { return RochePopularSearchStyle0; }
}, [1, "roche-popular-search", {
        "label": [1],
        "value": [1],
        "translations": [32]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-popular-search"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-popular-search":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RochePopularSearch$1);
            }
            break;
    } });
}

const RochePopularSearch = RochePopularSearch$1;
const defineCustomElement = defineCustomElement$1;

export { RochePopularSearch, defineCustomElement };

//# sourceMappingURL=roche-popular-search.js.map